
import {timer as observableTimer,  Observable ,  Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaymentService } from '../../services/payment.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NotificationsService } from 'angular2-notifications';
import { PaymentStatus } from '../../models/subscriptions/subscription.enums';
import { RouterService } from '../../services/routerService';
import { AuthService } from '../../auth/auth.service';
import { LoggedInUserService } from '../../auth/logged.in.user';

@Component({
    selector: 'subscribe',
    template: '<div class= "modal inmodal in" id="payment-failed-modal" tabindex="-1" role="dialog" data-backdrop="static"><div class="modal-dialog"><div class="modal-content animated fadeIn"><div class="modal-header"><h4 class="modal-title">Card Payment Failed</h4></div><div class= "modal-body" >Sorry - your payment has failed. Please re-enter your details and try again.<br/>If this error persists, please contact your card provider or a B2B system administrator.</div><div class= "modal-footer"><button type="button" class= "btn btn-success pull-right" (click)="redirectToPaymentPage()" >Ok</button></div></div></div></div>'
})
export class PaymentProcessingComponent implements OnInit {
    @BlockUI() blockUi: NgBlockUI;

    routeParamsSub: Subscription;

    private subscriptionId: number;

    constructor(private routerService: RouterService, private route: ActivatedRoute,
        private paymentService: PaymentService, private notificationsService: NotificationsService,
        private readonly authService: AuthService, private readonly loggedInUserService: LoggedInUserService) {
        this.routerService.doNotAddCurrentPageToRouteStack();
        $('#payment-failed-modal').modal();
        $('#payment-failed-modal').modal('hide');
    }

    ngOnInit() {
        this.blockUi.start('Processing 3D secure confirmation. Please do not refresh this page.');

        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            var id = +params['id'];

            let timer = observableTimer(10000).subscribe(() => {
                timer.unsubscribe();
                timer = null;

                this.paymentService.getPaymentStatus(id).subscribe((response: PaymentStatus) => {
                    switch (response) {
                        case PaymentStatus.Paid:
                            {
                                this.blockUi.stop();                                

                                this.authService.getNewToken().subscribe(() => {
                                    this.loggedInUserService.refreshUserClaims();

                                    setTimeout(() => {
                                        this.routerService.router.navigateByUrl('/account/card');
                                    });

                                    this.notificationsService.success('Payment Successful',
                                        'Secure 3D authorisation successful and payment made.');

                                    var user = this.loggedInUserService.getCurrentUser();
                                    if (user.canAdHoc('notSubscribed')) {
                                        alert('Please log back into the website to complete the upgrade process.');
                                        this.authService.logout();
                                    }
                                    
                                });
                                break;
                            }
                        case PaymentStatus.Pending:
                            {
                                this.tryAgain(id);
                                break;
                            }
                        default:
                            {
                                this.subscriptionId = id;
                                $('#payment-failed-modal').modal();
                                this.blockUi.stop();
                                break;
                            }
                    }
                    //this.blockUi.stop();
                },
                    () => {
                        this.blockUi.stop();
                        var user = this.loggedInUserService.getCurrentUser();
                        if (user.canAdHoc('notSubscribed')) {
                            alert('Please log back into the website to complete the upgrade process.');
                            this.authService.logout();
                        }
                    });
            });
        });
    }

    ngOnDestroy() {
        this.blockUi.stop();
    }

    tryAgain(id: number) {

        let timer = observableTimer(15000).subscribe(() => {
            timer.unsubscribe();
            timer = null;

            this.paymentService.getPaymentStatus(id).subscribe((response: PaymentStatus) => {
                switch (response) {
                    case PaymentStatus.Paid:
                        {
                            this.authService.getNewToken().subscribe(() => {
                                this.loggedInUserService.refreshUserClaims();

                                this.routerService.router.navigateByUrl('/account/card');
                                this.blockUi.stop();

                                this.notificationsService.success('Payment Successful',
                                    'Secure 3D authorisation successful and payment made.');

                                var user = this.loggedInUserService.getCurrentUser();
                                if (user.canAdHoc('notSubscribed')) {
                                    alert('Please log back into the website to complete the upgrade process.');
                                    this.authService.logout();
                                }

                            });
                            break;
                        }
                    case PaymentStatus.Pending:
                        {
                            this.routerService.router.navigateByUrl('/account/subscriptions');
                            this.notificationsService.alert('Payment Pending',
                                'Secure 3D authorisation has not been received. Wait 5 minutes and then refresh the page.');
                            this.blockUi.stop();
                            break;
                        }
                    default:
                        {
                            this.subscriptionId = id;
                            $('#payment-failed-modal').modal();
                            this.blockUi.stop();
                            break;
                        }
                }
                //this.blockUi.stop();
            },
                () => {
                    this.blockUi.stop();
                    var user = this.loggedInUserService.getCurrentUser();
                    if (user.canAdHoc('notSubscribed')) {
                        alert('Please log back into the website to complete the upgrade process.');
                        this.authService.logout();
                    }
                });
        });
    }

    redirectToPaymentPage() {
        $('#payment-failed-modal').modal('hide');
        this.routerService.router.navigateByUrl(`/account/subscribe/${this.subscriptionId}`);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/subscription/payment.processing.component.ts